<template lang="pug">
  .sideNav(:class="{'sideNav--open': sidenavState, 'sideNav--right': isRight}")
    van-icon.sideNav__openBtn(name="menu" @click="openSidenav" v-if="sidenavOpenBtn")

    .sideNav__bar
      nav.sideNav__list(ref="sideNavList")
        slot

      van-icon.sideNav__closeBtn(name="close" @click="closeSidenav")
      .sideNav__version v-{{ version }}

    .sideNav__overlay(@click="closeSidenav" v-if="isOverlay")
</template>

<script>
// Se puede lanzar desde el componente padre
// añadiendo una referencia al Sidenav(ref="sideNavTop")
// y luego añadir el método
// methods: {
//   openNavTop() { this.$refs.sideNavTop.openSidenav(); }
// }

// TODO: Add more position (top, bottom)
// TODO: Custom icon
// TODO: Add more effects
// https://github.com/mbj36/vue-burger-menu/blob/master/src/components/Menu/reveal.vue
import { mapGetters, mapActions } from 'vuex';
import { version, build } from '../../package.json';

export default {
  name: 'Sidenav',
  data() {
    return {
      isRight: false,
      isOverlay: true,
      sidenavOpenBtn: true,
    };
  },
  computed: {
    ...mapGetters({
      sidenavState: 'globalModule/isSideNavOpen',
    }),

    version() {
      return `${version}.${build}`;
    },
  },

  props: {
    open: {
      type: Boolean,
      required: false,
    },
    right: {
      type: Boolean,
      required: false,
    },
    disableOpenBtn: {
      type: Boolean,
      required: false,
    },
    disableEsc: {
      type: Boolean,
      required: false,
    },
    disableOverlay: {
      type: Boolean,
      required: false,
    },
    onStateChange: {
      type: Function,
      required: false,
    },
  },

  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
      closeSidenav: 'globalModule/closeSidenav',
    }),

    closeSidenavOnEsc(e) {
      e = e || window.event;
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.closeSidenav();
      }
    },
  },

  mounted() {
    if (this.open) {
      this.openSidenav();
    }
    if (this.right) {
      this.isRight = true;
    }
    if (this.disableOverlay) {
      this.isOverlay = false;
    }
    if (this.disableOpenBtn) {
      this.sidenavOpenBtn = false;
    }
    if (!this.disableEsc) {
      document.addEventListener('keyup', this.closeSidenavOnEsc);
    }

    // this.$refs.sideNavList.addEventListener('click', this.closeSidenav());
  },

  destroyed() {
    document.removeEventListener('keyup', this.closeSidenavOnEsc);
  },
};
</script>
